// Geteilter TRO-Sessions-Header (DESIGN.md §5.7): Logo + SESSIONS — <studio> links, Session-Name
// pixel-zentriert in der Mitte, rechts Status-Badge (ON AIR / ● RECORDING) + optionaler Token.
// Wird von LiveShell UND den Customer-Vorstufen (CustomerPage) genutzt → ein konsistenter Header überall.
import type { ReactNode } from 'react';
import styles from './SessionHeader.module.css';

export type SessionStatus = 'idle' | 'on-air' | 'recording';

export function SessionHeader({ studio, title, status = 'idle', token, right }: {
  studio: string;
  title?: string;
  status?: SessionStatus;
  token?: string;
  right?: ReactNode;
}) {
  return (
    <header className={styles.header}>
      <div className={styles.brand}>
        <img src="/brand/tro_logo_pos.svg" alt="TRO" className={styles.logo} />
        <span className={styles.brandText}>Sessions{studio ? ` — ${studio}` : ''}</span>
      </div>
      {title && <h1 className={styles.title}>{title}</h1>}
      <div className={styles.right}>
        {status === 'recording' && <span className={styles.recording}>● Recording</span>}
        {status === 'on-air' && <span className={styles.onAir}>● On Air</span>}
        {token && <span className={styles.token}>{token}</span>}
        {right}
      </div>
    </header>
  );
}
